import { Module } from "../plugins/_application";
import { distance } from "../utils/_calculate-distance";
import { debounce } from "../utils/debounce";

var $ = jQuery;

export default class NavigationScroll extends Module {

    ready(app) {

        const MAIN_NAV = document.getElementById('main_header');
        const VISIBLE_ADMIN_BAR = document.querySelector('body.admin-bar');
        const DEFAULT_CLASSES = MAIN_NAV.classList.value;
        const NAV_BREAKPOINT = 900;
        const SCROLL_LENGTH = 200;
        const SCROLLED_CLASS = 'scrolled';
        const ADMIN_BAR_HEIGHT = 46;

        let lastScrollPosition = 0;
        let ticking = false;
        let hasScrolled = false;

        function triggerScrollEvent(scrollPosition) {
            const WINDOW_WIDTH = window.innerWidth;

            if (WINDOW_WIDTH > NAV_BREAKPOINT) {
                if (scrollPosition > SCROLL_LENGTH && !hasScrolled) {
                    MAIN_NAV.classList = `${DEFAULT_CLASSES} ${SCROLLED_CLASS}`;
                    hasScrolled = true;
                } else if (scrollPosition < SCROLL_LENGTH && hasScrolled) {
                    MAIN_NAV.classList = '';
                    hasScrolled = false;
                }
            }

            if (WINDOW_WIDTH < 601 && VISIBLE_ADMIN_BAR) {
                let topNumber = ADMIN_BAR_HEIGHT - scrollPosition;

                if (scrollPosition >= ADMIN_BAR_HEIGHT) {
                    MAIN_NAV.style.top = 0;
                } else {
                    MAIN_NAV.style.top = topNumber + 'px';
                }
            }
        }

        function scrollHandler() {
            lastScrollPosition = distance.toTop();

            if (!ticking) {
                window.requestAnimationFrame(function() {
                triggerScrollEvent(lastScrollPosition);
                ticking = false;
                });

                ticking = true;
            }
        }

        const NAV_RESIZE  = debounce(() => {
            if (window.innerWidth > 600) {
                MAIN_NAV.style.top = '';
            } else {
                if (MAIN_NAV.classList.contains('scrolled')) {
                    MAIN_NAV.classList.remove('scrolled');
                }
            }
            scrollHandler();
        }, 500);
        
        window.addEventListener('scroll', scrollHandler);
        window.addEventListener('resize', NAV_RESIZE);

        scrollHandler();

    }
}